import React from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { Checkbox, FormControl, Input, Textarea } from '../../../Components/Form';
import { Text } from '../../../globalStyles';
import { FormFields } from '../types';

type CampusResourceFormProps = {
  register: ReturnType<typeof useForm<FormFields>>['register'];
  resourceCrisis?: boolean;
  setResourceCrisis: (value: boolean) => void;
};

const CrisisLabel = styled(Text.bodyBold)`
  position: relative;
  bottom: 0.25em;
`;

export const CampusResourceForm = ({
  register,
  resourceCrisis,
  setResourceCrisis,
}: CampusResourceFormProps) => {
  return (
    <>
      <Text.h2 className="mb2">Contact &amp; Details</Text.h2>
      <Text.body className="mb3">
        All fields are optional -- fill out any applicable fields below.
      </Text.body>
      <FormControl name="contact" label="Contact Person">
        <Text.bodySmallGrey>
          If there is a specific person to contact in regards to this resource, please add their
          name.
        </Text.bodySmallGrey>
        <Input name="contact" ref={register} placeholder="Jane Smith" />
      </FormControl>
      <FormControl name="location" label="Location / Address">
        <Input name="location" ref={register} placeholder="Address / campus building" />
      </FormControl>
      <FormControl name="phone" label="Phone">
        <Text.bodySmallGrey>
          If this resource can be contacted by phone, please add the number number below.
        </Text.bodySmallGrey>
        <Input name="phone" ref={register} placeholder="603-325-2312" />
      </FormControl>
      <FormControl name="email" label="Email Address">
        <Input name="email" ref={register} placeholder="resource@college.edu" />
      </FormControl>
      <FormControl name="hours" label="Hours">
        <Input name="hours" ref={register} />
      </FormControl>
      <FormControl name="website" label="Website">
        <Input name="website" ref={register} placeholder="https://college.edu/counseling" />
      </FormControl>
      <FormControl name="description" label="Additional Details">
        <Text.bodySmallGrey>Short description of offered resource</Text.bodySmallGrey>
        <Textarea
          name="description"
          ref={register}
          placeholder="Crisis, consultation, and counseling services"
        />
      </FormControl>
      <FormControl name="showAsCrisisResource">
        <Checkbox
          name="showAsCrisisResource"
          checked={resourceCrisis}
          onChange={() => setResourceCrisis(!resourceCrisis)}
        >
          <CrisisLabel>Show as a Crisis Resource</CrisisLabel>
        </Checkbox>
      </FormControl>
    </>
  );
};
